module.exports = __webpack_public_path__ + "static/img/guide-35.9576d90f.png";